var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4834 19.7755C15.8957 19.7755 20.2832 15.3879 20.2832 9.97565C20.2832 4.56336 15.8957 0.175842 10.4834 0.175842C5.07112 0.175842 0.683594 4.56336 0.683594 9.97565C0.683594 15.3879 5.07112 19.7755 10.4834 19.7755ZM15.1713 5.28774C14.7943 4.91075 14.1831 4.91075 13.8061 5.28774L5.79549 13.2984C5.4185 13.6754 5.4185 14.2866 5.79549 14.6636C6.17248 15.0405 6.78369 15.0405 7.16068 14.6636L15.1713 6.65293C15.5483 6.27594 15.5483 5.66472 15.1713 5.28774Z",
    fill: "#E64067"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.b8f20ee046ce4baae183042ec278ffa6.svg";
export { ForwardRef as ReactComponent };